module.exports = __webpack_public_path__ + "img/flame_gunner_small.6949620c.png";